<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LeadsOrderDropdown from './LeadsOrderDropdown.vue';

defineProps({
  totalLeadsCount: { type: Number, default: 0 },
  activeOrderDescription: { type: String, default: '' },
  orderBy: { type: String, default: '' },
  orderByOptions: { type: Array, default: () => [] },
  selectedCount: { type: Number, default: 0 },
});

const emit = defineEmits(['order-change', 'clear-selection']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div
    class="flex flex-col gap-3 px-4 py-4 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-10"
  >
    <div>
      <p class="text-[13px]">
        <span
          class="text-lais-primary underline decoration-lais-warning decoration-[1.5px] underline-offset-[3px]"
        >
          Exibindo {{ totalLeadsCount }}
          {{ totalLeadsCount === 1 ? 'cliente' : 'clientes' }}
        </span>
      </p>
      <p class="mt-1 text-[12px] text-lais-text-muted">
        {{ activeOrderDescription }}
      </p>
    </div>
    <LeadsOrderDropdown
      :model-value="orderBy"
      :options="orderByOptions"
      @update:model-value="emit('order-change', $event)"
    />
    <div class="text-right text-[12px] text-lais-text-body">
      <p class="font-semibold text-lais-primary">
        Selecione os leads via Casa da Lais
      </p>
      <p>
        Via seleção manual ·
        <span v-if="selectedCount === 0">Selecione leads para baixar</span>
        <button
          v-else
          type="button"
          class="font-semibold text-lais-primary underline decoration-lais-warning underline-offset-[3px]"
          @click="emit('clear-selection')"
        >
          Remover todos os itens
        </button>
      </p>
    </div>
  </div>
</template>
